export default "__VITE_ASSET__DbTL4spc__"